import { Component, ojs, app, payload } from "modular-openscriptjs";
import { dom } from "../../../fotastart";
import { pageInfo } from "../../../helpers";
import { PAGES } from "../../../declarations";

const h = app("h");
const broker = app("broker");
const $e = app("$e");

export default class Password extends Component {
    constructor() {
        super("PasswordPage");
    }

    render(...args) {
        
        pageInfo(PAGES.CHANGE_PASSWORD);

        return h.div(
            { class: "py-md-5" },
            h.div(
                {
                    class: "alert alert-info",
                    role: "alert",
                },
                "If you signed in with a social account i.e Google, etc, please use the password sent to your email as your current password."
            ),

            h.div(
                { class: "form-field required-field" },
                h.label({ for: "profile-current-password" }, "Current Password:"),
                h.input({
                    type: "password",
                    name: "current-password",
                    class: "form-control unicase-form-control password-input",
                    id: "profile-current-password",
                })
            ),

            h.div(
                { class: "form-field required-field mb-4" },
                h.label({ for: "profile-new-password" }, "New Password:"),
                h.input({
                    type: "password",
                    name: "new-password",
                    class: "form-control unicase-form-control password-input",
                    id: "profile-new-password"
                })
            ),

            h.div(
                { class: "form-field required-field mb-4" },
                h.label({ for: "profile-confirm-password" }, "Confirm Password:"),
                h.input({
                    type: "password",
                    name: "confirm-password",
                    class: "form-control unicase-form-control password-input",
                    id: "profile-confirm-password"
                })
            ),

            h.div(
                { class: "form-check mb-4" },
                h.input({
                    type: "checkbox",
                    name: "show-password",
                    class: "form-check-input",
                    id: "profile-show-password",
                    onclick: this.method('showPassword', ['${this}']),
                }),
                h.label({ for: "profile-show-password" }, "Show Password:"),
            ),

            h.div(
                { class: "text-xs-right" },
                h.button(
                    {
                        type: "button",
                        class: "btn btn-rounded btn-primary",
                        onclick: this.method("updatePassword"),
                    },
                    h.span({ class: "me-2" }, "change Password"),
                    h.i({ class: "fa-solid fa-check" })
                )
            ),
            ...args
        );
    }

    updatePassword(){
        let password = dom.id('profile-current-password')?.value;
        let newPassword = dom.id('profile-new-password')?.value;
        let confPassword = dom.id('profile-confirm-password')?.value;

        broker.broadcast($e.user.needs.password.change, payload({password, newPassword, confPassword}));
    }

    showPassword(elem) {
        let passwords = [
            dom.id('profile-current-password'),
            dom.id('profile-new-password'),
            dom.id('profile-confirm-password'),
        ];

        if(elem?.checked) {
            passwords.forEach(el => el.setAttribute('type', 'text'));
        }
        else {
            passwords.forEach(el => el.setAttribute('type', 'password'));
        }

        console.log(passwords);
    }
}
